export const BREAKPOINT_MOBILE = "768px"; 
export const BREAKPOINT_TABLET = "872px";

export const BREAKPOINT_HORIZONTAL = "700px";